import React, { Component } from 'react';
import './setup.css';
import { graphql, compose } from 'react-apollo'
import { answerQuestion } from "../graphql/mutations.js"
import { sessionQuery } from "../graphql/queries.js"
import update from 'immutability-helper';
import { withCookies } from 'react-cookie';

import Chat from "../components/chat.js";
import SurveySetup from "../components/survey-setup.js";

class MainPage extends Component {

  constructor(props) {
    super(props)

    this.state = {
      messageHistory: props.messageHistory || [],
      messageGroup: null,
      errorMessage: null,
      setupErrorMessage: null,
      delayFirstMessage: false
    }

    if (!props.cookies.get("session_cookie")) {
      console.log("No session id. Rerouting")
      this.props.history.push("/")
      console.log(this.props.history)
    }

    this.addMessage = this.addMessage.bind(this);

    console.log(this.props)
  }

  shouldComponentUpdate(nextProps, nextState) {
    // console.log("UPDATE?", this.state, nextState)
    const loadingChanged = nextProps.data.loading !== this.props.data.loading || nextState.answerLoading !== this.state.answerLoading
    if (loadingChanged) return true

    if (this.state.delayFirstMessage !== nextState.delayFirstMessage) return true

    const errorChanged = nextState.errorMessage !== this.state.errorMessage
    if (errorChanged) return true

    const nullGroups = !this.state.messageGroup && !nextState.messageGroup

    const newGroup = nullGroups ? false : (
      (this.state.messageGroup && !nextState.messageGroup)
      || (!this.state.messageGroup && nextState.messageGroup)
      || (this.state.messageGroup.id !== nextState.messageGroup.id)
    )

    // const optimisticResponse = nullGroups || newGroup ? false 
    //   : !this.state.messageGroup.userMessage && nextState.messageGroup.userMessage
    //   || this.state.messageGroup.userMessage !== nextState.messageGroup.userMessage

    return newGroup && nextState.messageGroup
  }

  componentWillReceiveProps(nextProps) {
    console.log("RECEIVING PROPS", nextProps.data)
    // console.log(nextProps)

    if (nextProps.data.survey_session && 
      nextProps.data.survey_session.results_redirect) {
        
      // Navigate to results page.
      setTimeout(() => {
        let path = nextProps.data.survey_session.results_redirect
        this.props.history.replace({
          pathname: path
        })
      }, 250)
    }

    if (nextProps.data.error) {
      return
    }

    if (!nextProps.data.loading) {
      // Update state based on props received
      this.setState((prevState, props) => {
        let newHistory = []
        let messageGroup = null
        let deleteIndex = -1

        if (nextProps.data.survey_session) {

          let index = 0
          const system_responses = nextProps.data.survey_session.system_responses

          const historyIds = prevState.messageHistory.map(grp => grp.id)

          const is_survey_setup = this.props.data.survey_session && this.props.data.survey_session.is_survey_setup

          while(index < system_responses.length && system_responses[index].selected_answer) {
            if (!historyIds.includes(system_responses[index].id) && !is_survey_setup) {
              newHistory.push(this.extractMessageGroup(system_responses[index]))
            }
            index += 1
          }

          const current_response = nextProps.data.survey_session.system_responses[index]

          if (current_response) {
            messageGroup = this.extractMessageGroup(current_response)
            deleteIndex = historyIds.findIndex(id => id === messageGroup.id)
          }
        }

        return {
          messageGroup: messageGroup,
          messageHistory: update(
            prevState.messageHistory,
            { 
              $push: newHistory,
              $splice: [[deleteIndex, deleteIndex > -1 ? 1 : 0]]
            }
          )
        }
      })
    } 
  }

  extractMessageGroup(system_response) {
    return {
      id: system_response.id,
      systemMessages: system_response.messages
        .map((msg, i) => {
          return {
            key: system_response.id + "-" + i.toString(),
            system: true,
            contents: msg
          }
        }),
      userMessage: system_response.selected_answer ?
          {
            key: system_response.id + "-selected_answer",
            system: false,
            text: system_response.selected_answer
          } : null,
      input: this.extractInput(system_response),
      loading: false
    }
  }

  extractInput(system_response) {
    let input = {
      type: "single",
      active: !system_response.selected_answer,
      options: system_response.answer_choices,
      question_id: system_response.id,
      singleline: system_response.singleline,
      require_validation: system_response.require_validation,
      long_answers: system_response.long_answers
    }

    if (system_response.slider && system_response.multiselect) {
      input.type = "multi-slider"
    } else if (system_response.slider) {
      input.type = "slider"  
    } else if (system_response.freetext) {
      input.type = "text"
    } else if (system_response.multiselect) {
      input.type = "multi"
    }

    return input
  }

  addMessage(answer, always_fetch = false) {
    let system_responses = this.props.data.survey_session.system_responses
    answer.system_response = Object.assign({}, system_responses.find(sr => sr.id === answer.question_id))
    if (always_fetch) {
      answer.no_fetch = false
    } else {
      answer.no_fetch = system_responses.findIndex(sr => sr.id === answer.question_id) !== system_responses.length - 1
    }
    console.log("ANSWERING", answer)

    this.setState({
      answerLoading: true
    })

    if (answer.additional_data) delete answer.additional_data["meta"]
    this.props.answerQuestion(answer)
      .then(({ data, errors }) => {
        console.log("QUESTION ANSWERED", data, errors)
        let errorMsg = ""
        if (errors && errors[0]) errorMsg = errors[0].message
        if (!this.props.data.survey_session.is_survey_setup) {
          this.setState({
            answerLoading: false,
            errorMessage: errorMsg
          })
        } else {
          // Do not erase errors if on setup page.
          this.setState(prevState => {
            return {
              answerLoading: false,
              setupErrorMessage: errorMsg || prevState.setupErrorMessage
            }
          })
        }
        // this.render()
      })
      .catch((error) => {
        console.error("ERROR ANSWERING QUESTION!", error.message)
        console.log(error.name)
        this.setState({
          errorMessage: error.message,
          answerLoading: false
        })
        // switch (error.name) {
        //   case "Network"
        // }

      })
  }

  render() {
    // For static non chat pages
    if (this.props.data && this.props.data.survey_session && this.props.data.survey_session.is_survey_setup) {
      return (
        <SurveySetup questions={this.props.data.survey_session.system_responses}
                     addMessage={this.addMessage} 
                     loading={this.props.data.loading || this.state.answerLoading}
                     errorMessage={this.state.setupErrorMessage} />
      )
    }

    // For first load of chat
    if (this.state.delayFirstMessage && this.state.messageHistory.length === 0) {
      setTimeout(() => {
        this.setState({
          delayFirstMessage: false
        })
      }, 2000)
      return (
        <Chat messageHistory={[]}
              loading={true} 
              errorMessage={this.state.errorMessage} />
      )
    }

    return (
      <Chat messageHistory={this.state.messageHistory} 
            messageGroup={this.state.messageGroup} 
            addMessage={this.addMessage}
            percentComplete={this.props.data && this.props.data.survey_session ? this.props.data.survey_session.percent_complete : 0}
            loading={this.props.data.loading || this.state.answerLoading}
            errorMessage={this.state.errorMessage} />
    );
  }
}


export default withCookies(
  compose(
    graphql(answerQuestion, {
      props: ({ mutate, ownProps }) => ({
        answerQuestion: ({ selected_answer, question_id, additional_data, system_response, no_fetch }) =>
          mutate({ 
            variables: { 
              input: {
                text: selected_answer,
                session_id: ownProps.cookies.get("session_cookie") ? ownProps.cookies.get("session_cookie").session_id : "",
                question_id: question_id,
                additional_data: additional_data
              } 
            },
            optimisticResponse: {
              __typename: 'Mutation',
              answerQuestion: Object.assign(system_response, { selected_answer: selected_answer })
            },
            refetchQueries: no_fetch ? [] : [
              "getUpdatedSession"
            ],
            errorPolicy: 'all'
          })
      })
    }),
    graphql(sessionQuery, {
      options: ({ cookies }) => (
        { 
          variables: { id: cookies.get("session_cookie") ? cookies.get("session_cookie").session_id : "" }, 
          notifyOnNetworkStatusChange: true, 
          errorPolicy: 'all' 
        }
      )
    })
  )(MainPage)
);


// WEBPACK FOOTER //
// ./src/pages/main.js